import Topbar from '@core/layout/topbar'
import StatusBar from '@core/layout/statusbar'
import PanelRail from '@core/layout/rail/PanelRail'
import Ribbon from '@core/layout/ribbon'
import { useRibbonShortcuts } from '@core/layout/ribbon/useRibbonShortcuts'
import MobileBar from '@core/layout/MobileBar'
import { useIsMobile } from '@core/useIsMobile'
import ViewerPage from '@viewer/ViewerPage'
import PopupsHost from '@viewer/popups'
import RecoveryPrompt from '@core/session/RecoveryPrompt'
import SessionRestoreBanner from '@core/session/SessionRestoreBanner'
import VersionUpdateBanner from '@core/layout/VersionUpdateBanner'
import RibbonMovesNotice from '@core/layout/ribbon/RibbonMovesNotice'
import { useUnsavedWorkGuard } from '@core/session/useUnsavedWorkGuard'

/**
 * Local-mode shell: Topbar + Ribbon over the viewer with no router
 * involved. Cloud mode goes through WorkspaceLayout instead so the
 * same Topbar/Ribbon survives module navigation.
 *
 * PopupsHost is mounted here too so the floating panels (Aparência,
 * Colorir por…, FloatingProperties, ModelInfo) work in local mode,
 * not just when authenticated.
 */
function ViewerShell() {
  useRibbonShortcuts()
  useUnsavedWorkGuard()
  const isMobile = useIsMobile()
  return (
    <div className="flex h-full flex-col bg-[var(--color-bg)] text-[var(--color-text)]">
      <Topbar />
      {/* Os dois avisos vivem nas duas cascas (aqui e no
          WorkspaceLayout): quem usa o modo local tem o mesmo problema
          do separador aberto há horas e do friso que mudou. */}
      <VersionUpdateBanner />
      {/* Abrir sessão em modo local precisa de quem reponha os IFCs: é
          este banner que os vai buscar à cache do browser e pede os que
          faltarem. Em cloud vive no WorkspaceLayout, pela mesma razão. */}
      <SessionRestoreBanner />
      {/* On phones the ribbon is replaced by the bottom MobileBar so the
          canvas gets the full screen. */}
      {!isMobile && <Ribbon />}
      {!isMobile && <RibbonMovesNotice />}
      {/* O `min-w-0` impede o contentor de se recusar a encolher
          abaixo do seu conteudo, que e' o que empurrava o painel de
          propriedades para fora do ecra no modo cloud. Aqui ainda nao
          dava pelo problema, mas a estrutura e' a mesma. */}
      <div className="flex min-h-0 min-w-0 flex-1">
        {/* A regua fica encostada a esquerda, fora da ViewerPage: ela
            nunca pode ser remontada, senao o contexto WebGL cai. */}
        {!isMobile && <PanelRail />}
        <ViewerPage />
      </div>
      {isMobile && <MobileBar />}
      {/* No telemovel o espaco vertical e' precioso e a barra inferior
          ja esta ocupada pelo MobileBar. */}
      {!isMobile && <StatusBar />}
      <PopupsHost />
      <RecoveryPrompt />
    </div>
  )
}

export default ViewerShell
